import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  top: 3px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: 5px 10px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.2);

  .pill {
    text-transform: uppercase;
  }
`;

export const Oval = styled.div`
  position: relative;
  cursor: pointer;

  .overlay {
    opacity: 0;
  }

  &:hover {
    .overlay {
      opacity: 1;
    }
  }
`;

export const Sphere = styled.img`
  border-radius: 50%;
  filter: brightness(1.1) contrast(1.2);
  position: relative;
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  transition: opacity 100ms;
`;

export const Details = styled.div`
  padding-bottom: 10px;
`;

export const Name = styled.div`
  padding-bottom: 4px;
  font-size: 14px;
  opacity: 0.85;
`;

export const Categories = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`;
